<template>
    <div>

        <section class="content">
        <div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Cetak File Keluarana</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                       
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="row">
                    <div class="col-sm-2">
                        <span>Jenis Laporan</span>
                    </div>
                    <div class="col-sm-10">
                        <div class="form-group">
                            <input type="radio" name="radio" id="radio1" class="with-gap">
                            <label for="radio1">Surat Pemberitahuan Pajak Terhutang (SPPT)</label>
                            <br>
                            <input type="radio" name="radio" id="radio2" class="with-gap">
                            <label for="radio2">Surat Tanda Terima Setoran (STTS)</label>
                            <br>
                            <input type="radio" name="radio" id="radio3" class="with-gap">
                            <label for="radio3">Daftar Himpunan Ketetapan Pajak (DHKP)</label>
                            <br>
                            <input type="radio" name="radio" id="radio4" class="with-gap">
                            <label for="radio4">Surat Keputusan Pengurangan</label>
                            <br>
                            <input type="radio" name="radio" id="radio5" class="with-gap">
                            <label for="radio5">Surat Keputusan Pengurangan Kolektif</label>
                            <br>
                            <input type="radio" name="radio" id="radio6" class="with-gap">
                            <label for="radio6">Lampiran SK Pengurangan Kolektif</label>
                            <br>
                            <input type="radio" name="radio" id="radio7" class="with-gap">
                            <label for="radio7">Surat Keputusan Keberatan</label>
                            <br>
                            <input type="radio" name="radio" id="radio8" class="with-gap">
                            <label for="radio8">Surat Keputusan Pembetulan</label>
                            <br>
                            <input type="radio" name="radio" id="radio9" class="with-gap">
                            <label for="radio9">Surat Keputusan Pembetulan Kolektif</label>
                            <br>
                            <input type="radio" name="radio" id="radio10" class="with-gap">
                            <label for="radio10">Lampiran SK Pembetulan Kolektif</label>
                            <br>
                            <input type="radio" name="radio" id="radio11" class="with-gap">
                            <label for="radio11">Surat Keputusan Pembatalan</label>
                            <br>
                            <input type="radio" name="radio" id="radio12" class="with-gap">
                            <label for="radio12">Surat Keputusan Pembatalan Kolektif</label>
                            <br>
                            <input type="radio" name="radio" id="radio13" class="with-gap">
                            <label for="radio13">Lampiran SK Pembatalan Kolektif</label>
                            <br>
                            <input type="radio" name="radio" id="radio14" class="with-gap">
                            <label for="radio14">SK Penentuan Kembali Jatuh Tempo Atas SPPT</label>
                        </div>
                    </div>
                </div>


        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {

    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
